export default "__VITE_ASSET__BDtHsPkL__"